import React, { useMemo } from 'react';
import { formatMoney, formatNumber } from '../../Shared/Formatters';

const MEDALS = ['🥇', '🥈', '🥉'];

function fmt(value, format) {
    if (value == null || isNaN(value)) return '—';
    if (format === 'currency') return formatMoney(value);
    if (format === 'integer') return formatNumber(value, 0);
    return String(value);
}

/**
 * Ranking table — medalled top-3, clickable rows that fire a drill suggestion.
 * Props mirror the block builder shape: { rows, valueFormat, medalled, cols, drillTemplate }.
 */
export default function RankingTable({ title, rows, valueFormat, medalled, cols, drillTemplate, onSuggest }) {
    const showTxns = useMemo(() => rows?.some(r => r.txns != null), [rows]);
    const showShare = useMemo(() => rows?.some(r => r.sharePct != null), [rows]);
    if (!rows?.length) return null;

    function handleClick(row) {
        if (!drillTemplate || !onSuggest) return;
        const text = drillTemplate.split('{name}').join(row.name || '');
        onSuggest(text);
    }

    const clickable = Boolean(drillTemplate && onSuggest);
    return (
        <div className="chat-block">
            {title && <div className="chat-block-title">{title}</div>}
            <table className="ranking-table">
                <thead>
                    <tr>
                        <th>{cols?.name || '#'}</th>
                        <th style={{ textAlign: 'end' }}>{cols?.value || ''}</th>
                        {showTxns && <th style={{ textAlign: 'end' }}>{cols?.txns || ''}</th>}
                        {showShare && <th style={{ textAlign: 'end' }}>{cols?.share || ''}</th>}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, i) => (
                        <tr
                            key={i}
                            className={clickable ? 'clickable' : ''}
                            onClick={clickable ? () => handleClick(row) : undefined}
                            title={clickable ? (drillTemplate.split('{name}').join(row.name)) : undefined}
                        >
                            <td>
                                <span className="medal">{medalled && i < 3 ? MEDALS[i] : `${i + 1}.`}</span>
                                {row.name}
                            </td>
                            <td className="num">{fmt(row.value, valueFormat)}</td>
                            {showTxns && <td className="num">{row.txns != null ? formatNumber(row.txns, 0) : '—'}</td>}
                            {showShare && <td className="num">{row.sharePct != null ? `${row.sharePct.toFixed(1)}%` : '—'}</td>}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
